import { useEffect, useState } from "react";

const SHOWN_KEY = "afwn_exit_shown";
export const LEAD_KEY = "afwn_lead_done";
const MIN_TIME_MS = 8000;

export const markLeadDone = () => { try { localStorage.setItem(LEAD_KEY, "1"); } catch { /* ignore */ } };

const alreadyHandled = () => {
  try { return sessionStorage.getItem(SHOWN_KEY) === "1" || localStorage.getItem(LEAD_KEY) === "1"; } catch { return true; }
};

export const useExitIntent = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (alreadyHandled()) return undefined;
    const started = Date.now();
    let lastY = window.scrollY;
    let fired = false;

    const fire = () => {
      if (fired || Date.now() - started < MIN_TIME_MS) return;
      fired = true;
      try { sessionStorage.setItem(SHOWN_KEY, "1"); } catch { /* ignore */ }
      setOpen(true);
    };
    const onMouseOut = (e) => { if (!e.relatedTarget && e.clientY <= 0) fire(); };
    const onScroll = () => {
      const y = window.scrollY;
      const depth = (y + window.innerHeight) / document.documentElement.scrollHeight;
      if (lastY - y > 220 && depth > 0.4) fire();
      lastY = y;
    };
    document.addEventListener("mouseout", onMouseOut);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      document.removeEventListener("mouseout", onMouseOut);
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return [open, setOpen];
};
